import { Component, OnInit, ViewChildren, QueryList } from '@angular/core';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { RequestService } from 'src/app/onelog/services/request.service';
import { CHAP_TITLES_IN_PROD, GET_USER_EMAIL } from 'src/app/onelog/common/config/url';
import { MAX_SIZE } from 'src/app/onelog/common/config/common';
import { DropDownSingleSelectComponent } from 'src/app/onelog/common/fields/drop-down-single-select/drop-down-single-select.component';
import { ProductSatusService } from 'src/app/onelog/services/product-status.service';
import {
  DROP_DOWN_SETTING_BOOKTYPE, DEFAULT_CHAPTERWISE_TITLES_STATUSES
} from 'src/app/onelog/common/config/dropdown-config';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { AppEvent } from 'src/app/onelog/interface/DropDownEvents';
import { DateSelectComponent } from 'src/app/onelog/common/fields/date-select/date-select.component';

@Component({
  selector: 'app-chapterwise-titles-in-production',
  templateUrl: './chapterwise-titles-in-production.component.html',
  styleUrls: ['./chapterwise-titles-in-production.component.css'],
})
export class ChapterwiseTitlesInProductionComponent implements OnInit {
  constructor(
    private _requestService: RequestService,
    private _productStatus: ProductSatusService,
  ) {}

  products: any = [];
  totalProducts: number = 0;
  perPage: number = 0;
  lastPage: number = 0;
  currentPage: number = 1;
  showSearchLoading: boolean = false;
  pageSize: number = 25;
  maxSize: number = MAX_SIZE;
  searchBtnText: string = 'Search';
  responseData: any = [];
  selectedStatus: any = [...DEFAULT_CHAPTERWISE_TITLES_STATUSES];
  productId: string = '';
  selectedBookType: any[] = [];
  selectedProductType: any[] = [];
  selectedPPD: string = '';
  selectedPPDOption : string = '';
  DefaultselectedPPD: string = '';
  selectedPublishedDate: string = '';
  selectedPublishedDateOption: string = '';
  selectedContractedDate: string = '';
  selectedContractedDateOption: string = '';
  dateOptions: any = [];
  receivedDate!: NgbDate;
  listStatus: any = [];
  listBookType: any = [];
  listProductType: any = [];
  userEmail:string='';
  userData: any = '';
  userId: string = '';
  dropdownListStatus: any = [];
  @ViewChildren(DropDownSingleSelectComponent)
  DropDownSingleSelectComponent!: QueryList<DropDownSingleSelectComponent>;
   @ViewChildren(DateSelectComponent) NgbDate!: QueryList<DateSelectComponent>;
  dropdownSettingsBookType: IDropdownSettings = {};
  selectedDefaultItemsStatus: string[] = [...DEFAULT_CHAPTERWISE_TITLES_STATUSES];
  selectedDefaultProductType: string[] = [];
  selectedDefaultBookType: string[] = [];
  selectedStatusFilter: any = [];
  selectedBookTypeFilter: any = [];
  selectedProductTypeFilter: any = [];
  dateString: string = '';

  ngOnInit(): void {
    this.loadProductStatusList();
    this.intializeData();

    this.listBookType =  [
      { item_id: 'Normal', item_text: 'Normal' },
      { item_id: 'Mini', item_text: 'Mini' },
      { item_id: 'Maxi', item_text: 'Maxi' },
      { item_id: 'Licensed', item_text: 'Licensed' }
    ];
    this.listProductType =  [
      { item_id: 'Book', item_text: 'Book' },
      { item_id: 'Video', item_text: 'Video' },
      { item_id: 'Course', item_text: 'Course' },
      { item_id: 'AudioBook', item_text: 'AudioBook' }
    ];
    //['Normal', 'Mini', 'Maxi', 'Licensed'];

    this.dateOptions = [
      'less than',
      'greater than',
      'equal to',
      'not equal to'
    ];
    this.dropdownSettingsBookType = DROP_DOWN_SETTING_BOOKTYPE;
  }

  intializeData(): void {
    this.userData = localStorage.getItem('user');
    if (this.userData) {
      this.loadUserEmail({ id: this.userData });
    }
  }

  loadProductStatusList() {
    return this._productStatus.getStatusList().subscribe((data: {}) => {
      this.listStatus = data;
      let statusList: any = [];
 
      let tempSelectedDd: any = [];
      this.listStatus.data.forEach(function (currentValue: any, index: any, arr: any) {
        let obj: any = {};
        obj['item_id'] = currentValue.attributes.name;
        obj['item_text'] = currentValue.attributes.name;
        statusList.push(obj);
      });

      this.dropdownListStatus = statusList;

    });
  }

  loadProducts(postData: any = [], url: string = CHAP_TITLES_IN_PROD) {
    return this._requestService
      .postRequest(url, postData)
      .subscribe((data: {}) => {
        this.responseData = data;
        this.products = data;
        if (this.products.length > 0) {
          this.totalProducts = (
            data as { total_count: number }[]
          )[0].total_count;
        } else { this.totalProducts = 0 }
        this.perPage = 25;
        this.lastPage = Math.floor(this.totalProducts / 25) + 1;
        this.searchBtnText = 'Search';
        this.showSearchLoading = false;
      });
  }

    loadUserEmail(
    postData: { id: string },
    url: string = GET_USER_EMAIL
    ) {
    return this._requestService
      .postRequest(url, postData)
      .subscribe((data: {}) => {
      if (Array.isArray(data) && data.length > 0) {
        this.userEmail = data[0].user_name;
        this.loadProducts(this.createPostData());
      } else {
        console.warn('No user email found in response.');
      }
      });
  }

  createPostData() {
    this.setStatusFilterData();
    
    return {
      selectedStatus: Object.assign({}, this.selectedStatusFilter),
      productId: this.productId,
      selectedBookType: Object.assign({}, this.selectedBookTypeFilter),
      selectedProductType: Object.assign({}, this.selectedProductTypeFilter),
      ppd: this.selectedPPD,
      ppdOption: this.selectedPPDOption,
      publishedDate: this.selectedPublishedDate,
      publishedDateOption: this.selectedPublishedDateOption,
      contractedDate: this.selectedContractedDate,
      contractedDateOption: this.selectedContractedDateOption,
      page: this.currentPage,
      userId: this.userId,
      userData: this.userData,
      userEmail: this.userEmail,
    };
  }

  setStatusFilterData() {
    if ( this.selectedStatus.length > 0 ) {
      this.selectedStatusFilter['selected'] = this.selectedStatus;
    }
    
    if ( this.selectedBookType.length > 0 ) {
      this.selectedBookTypeFilter['selected'] = this.selectedBookType;
    }

    if ( this.selectedProductType.length > 0 ) {
      this.selectedProductTypeFilter['selected'] = this.selectedProductType;
    }

  }

  downloadReport() {
    this._requestService.download(
      CHAP_TITLES_IN_PROD,
      {
        is_download: 1,
        selectedStatus: Object.assign({}, this.selectedStatusFilter),
        productId: this.productId,
        selectedBookType: Object.assign({}, this.selectedBookTypeFilter),
        selectedProductType: Object.assign({}, this.selectedProductTypeFilter),
        ppd: this.selectedPPD,
        ppdOption: this.selectedPPDOption,
        publishedDate: this.selectedPublishedDate,
        publishedDateOption: this.selectedPublishedDateOption,
        contractedDate: this.selectedContractedDate,
        contractedDateOption: this.selectedContractedDateOption,
        page: this.currentPage,
        userId: this.userId,
        userData: this.userData,
        userEmail: this.userEmail,
      },
      '',
      'chapterwise_titles_in_production'
    );
  }

  updateSelectedType(event: AppEvent) {
    console.log(event);
    const data: any = event;

    if (event.type == 'status') {
      if (data.action == 'selected') {
        this.selectedStatus.push(data.item.item_text);
      } else {
        const index = this.selectedStatus.indexOf(data.item.item_text);
        this.selectedStatus.splice(index, 1);
      }
      if (data.action == 'deSelectedAll') {
        this.selectedStatus = [];
        this.selectedDefaultItemsStatus = [];
        this.selectedStatusFilter = {};
      }
    }

    if (event.type == 'bookType') {
      if (data.action == 'selected') {
        this.selectedBookType.push(data.item.item_text);
      } else {
        const index = this.selectedBookType.indexOf(data.item.item_text);
        this.selectedBookType.splice(index, 1);
      }
      if (data.action == 'deSelectedAll') {
        this.selectedBookType = [];
        this.selectedDefaultBookType = [];
        this.selectedBookTypeFilter = {};
      }
      console.log(this.selectedBookType);
    }
    if (event.type == 'productType') {
      if (data.action == 'selected') {
        this.selectedProductType.push(data.item.item_text);
      } else {
        const index = this.selectedProductType.indexOf(data.item.item_text);
        this.selectedProductType.splice(index, 1);
      }
      if (data.action == 'deSelectedAll') {
        this.selectedProductType = [];
        this.selectedDefaultProductType = [];
        this.selectedProductTypeFilter = {};
      }
      
      console.log(this.selectedProductType);
    }

    if (event.type == 'publishedDate') {
      this.selectedPublishedDate = data.dateString;
    }

    if (event.type == 'ppd') {
      this.selectedPPD = data.dateString;
    }

    if (event.type == 'contractedDate') {
      this.selectedContractedDate = data.dateString;
    }

    if ('selectedOption' in event && 'name' in event) {

      if (event.name == 'ppdOption') {
        this.selectedPPDOption = event.selectedOption;
      }

      if (event.name == 'publishedDateOption') {
        this.selectedPublishedDateOption = event.selectedOption;
      }

      if (event.name == 'contractedDateOption') {
        this.selectedContractedDateOption = event.selectedOption;
      }

  }
  }

  searchProduct() {
    this.searchBtnText = 'Searching...';
    this.showSearchLoading = true;
    this.loadProducts(this.createPostData());
        console.log({
        selectedStatus: Object.assign({}, this.selectedStatusFilter),
        productId: this.productId,
        selectedBookType: Object.assign({}, this.selectedBookTypeFilter),
        selectedProductType: Object.assign({}, this.selectedProductTypeFilter),
        ppd: this.selectedPPD,
        ppdOption: this.selectedPPDOption,
        publishedDate: this.selectedPublishedDate,
        publishedDateOption: this.selectedPublishedDateOption,
        contractedDate: this.selectedContractedDate,
        contractedDateOption: this.selectedContractedDateOption,
        page: this.currentPage,
        userId: this.userId,
        userData: this.userData,
        userEmail: this.userEmail,
    });
    this.searchBtnText = 'Search';
    this.showSearchLoading = false;
  }

  updatePageData(event: Event) {
    let eventData: any = event;
    let urlParams = '?page=' + eventData.currentPage;
    this.currentPage = eventData.currentPage;
    //console.log(eventData, urlParams);
    this.loadProducts(this.createPostData());
  }

  clearFilters() {
      (this.productId = ''),
      (this.selectedStatus = [...DEFAULT_CHAPTERWISE_TITLES_STATUSES]),
      (this.selectedStatusFilter = {}),
      (this.selectedBookTypeFilter = {}),
      (this.selectedBookType = []),
      (this.selectedDefaultBookType = []),
      (this.selectedProductTypeFilter = {}),
      (this.selectedProductType = []),
      (this.selectedDefaultProductType = []),
      (this.selectedDefaultItemsStatus = [...DEFAULT_CHAPTERWISE_TITLES_STATUSES]),
      (this.selectedPPD = ''),
      (this.selectedPPDOption),
      (this.selectedPublishedDate = ''),
      (this.selectedPublishedDateOption = ''),
      (this.selectedContractedDate = ''),
      (this.selectedContractedDateOption = ''),
      (this.currentPage = 1),
      this.clearAllDropDowns();
      this.clearAllDates();
  }

  clearAllDropDowns() {
    this.DropDownSingleSelectComponent.forEach((DropDownComp) => {
      DropDownComp.clearInput();
    });
    (this.intializeData())
  }

    clearAllDates(): void {
    this.NgbDate.forEach((datePickerComp) => {
      datePickerComp.clearDate();
    });
  }
}
